<template>
  <div class="reintroduci-password">
    <b-form-row class="b-form-row">
      <b-col sm="12" md="6" lg="6" xl="6">
        <h3>{{ labels.inserisci_nuova_password }}</h3>
      </b-col>
      <b-col sm="12" md="6" lg="6" xl="6">
        <h3>
          <b-form-input
            :size="size"
            class="b-form-input"
            id="utente"
            v-model="utente"
            maxlength="45"
            readonly
          ></b-form-input>
        </h3>
      </b-col>
    </b-form-row>
    <br />
    <b-form-row class="b-form-row">
      <b-col xs="12" sm="12" md="6" lg="6" xl="6">
        <b-form-group v-bind:label="labels.password">
          <b-form-input
            :size="size"
            class="b-form-input"
            id="password"
            v-model="password"
            maxlength="45"
            type="password"
            autocomplete="off"
          ></b-form-input>
          <p
            class="errore"
            id="errore-password"
            v-if="isError(errori.password)"
          >
            {{ labels_errori[errori.password] }}
          </p>
        </b-form-group>
      </b-col>
      <b-col xs="12" sm="12" md="6" lg="6" xl="6">
        <b-form-group v-bind:label="labels.conferma_password">
          <b-form-input
            :size="size"
            class="b-form-input"
            id="conferma-password"
            v-model="conferma_password"
            maxlength="45"
            type="password"
            autocomplete="off"
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-form-row>
    <br />
    <b-form-row class="b-form-row" style="text-align: center">
      <b-col xs="12" sm="12" md="6" lg="12" xl="12">
        <b-button
          variant="success"
          @click="aggiorna"
          :disabled="invio_in_corso"
          >{{ labels.aggiorna }}</b-button
        >
      </b-col>
    </b-form-row>
  </div>
</template>

<script>
import { utility } from "@/utility";
const axios = require("axios");

export default {
  name: "ReintroduciPassword",
  data() {
    return {
      labels: {},
      label_errori: {},
      size: "sm",
      password: "",
      conferma_password: "",
      errori: [],
      invio_in_corso: false,
    };
  },
  watch: {
    "$store.state.Lingua"(Lingua) {
      fn_CambiaLingua(Lingua, this);
    },
  },
  mixins: [utility],
  props: {
    utente: String,
    chiave: String,
  },
  methods: {
    aggiorna() {
      try {
        let me = this;

        if (!fn_ControllaDati(this)) {
          return;
        }

        let ServerURL = this.$store.state.ServerURL;

        let parametri = {
          chiave: this.chiave,
          password: this.password,
        };
        let parametri_json = JSON.stringify(parametri);

        fn_CambiaCursore("wait", this);
        this.invio_in_corso = true;

        axios({
          method: "post",
          url: ServerURL + "CheckIn/AggiornaPassword",
          data: parametri_json,
        })
          .then(function (response) {
            me.invio_in_corso = false;
            fn_CambiaCursore("default", me);
            if (response.data.errore == 0) {
              me.$bvModal
                .msgBoxOk(me.labels.password_aggiornata, {
                  title: me.labels.aggiornamento_password,
                })
                .then(function () {
                  me.$router.push("/login");
                });
            } else if (response.data.errore == -2) {
              me.registraErrore(
                response.data.esito,
                "ReintroduciPassword-aggiorna"
              );
            } else {
              me.$bvModal.msgBoxOk(me.labels_errori[response.data.esito], {
                title: me.labels_errori.si_e_verificato_un_errore,
                bodyClass: "errore",
              });
            }
          })
          .catch(function (error) {
            me.invio_in_corso = false;
            fn_CambiaCursore("default", me);
            me.registraErrore(error, "ReintroduciPassword-aggiorna");
          });
      } catch (error) {
        this.invio_in_corso = false;
        this.registraErrore(error, "ReintroduciPassword-aggiorna");
      }
    },
  },
  created() {
    fn_CambiaLingua(this.$store.state.Lingua, this);
  },
  beforeRouteEnter(to, from, next) {
    to.params.utente = to.query.utente;
    to.params.chiave = to.query.chiave;

    next();
  },
};

function fn_CambiaLingua(lingua, vm) {
  try {
    let labels_italiano = {
      inserisci_nuova_password: "Inserisci nuova password per utente",
      utente: "Utente",
      password: "Password",
      conferma_password: "Conferma password",
      aggiorna: "Aggiorna",
      password_aggiornata: "Password aggiornata correttamente",
      aggiornamento_password: "Aggiornamento password",
    };
    let labels_inglese = {
      inserisci_nuova_password: "Inserisci nuova password per utente",
      utente: "Utente",
      password: "Password",
      conferma_password: "Conferma password",
      aggiorna: "Aggiorna",
      password_aggiornata: "Password aggiornata correttamente",
      aggiornamento_password: "Aggiornamento password",
    };
    let labels_tedesco = {
      inserisci_nuova_password: "Inserisci nuova password per utente",
      utente: "Utente",
      password: "Password",
      conferma_password: "Conferma password",
      aggiorna: "Aggiorna",
      password_aggiornata: "Password aggiornata correttamente",
      aggiornamento_password: "Aggiornamento password",
    };
    let labels_francese = {
      inserisci_nuova_password: "Inserisci nuova password per utente",
      utente: "Utente",
      password: "Password",
      conferma_password: "Conferma password",
      aggiorna: "Aggiorna",
      password_aggiornata: "Password aggiornata correttamente",
      aggiornamento_password: "Aggiornamento password",
    };

    let labels_errori_italiano = {
      utente_non_trovato: "Utente non trovato",
      dato_obbligatorio: "Dato obbligatorio",
      password_non_corrispondenti: "Password non corrispondenti",
      si_sono_verificati_degli_errori: "Si sono verificati degli errori",
      si_e_verificato_un_errore: "Si è verificato un errore",
    };
    let labels_errori_inglese = {
      utente_non_trovato: "Utente non trovato",
      dato_obbligatorio: "Dato obbligatorio",
      password_non_corrispondenti: "Password non corrispondenti",
      si_sono_verificati_degli_errori: "Si sono verificati degli errori",
      si_e_verificato_un_errore: "Si è verificato un errore",
    };
    let labels_errori_tedesco = {
      utente_non_trovato: "Utente non trovato",
      dato_obbligatorio: "Dato obbligatorio",
      password_non_corrispondenti: "Password non corrispondenti",
      si_sono_verificati_degli_errori: "Si sono verificati degli errori",
      si_e_verificato_un_errore: "Si è verificato un errore",
    };
    let labels_errori_francese = {
      utente_non_trovato: "Utente non trovato",
      dato_obbligatorio: "Dato obbligatorio",
      password_non_corrispondenti: "Password non corrispondenti",
      si_sono_verificati_degli_errori: "Si sono verificati degli errori",
      si_e_verificato_un_errore: "Si è verificato un errore",
    };

    switch (lingua) {
      case "IT":
        vm.labels = labels_italiano;
        vm.labels_errori = labels_errori_italiano;
        break;
      case "EN":
        vm.labels = labels_inglese;
        vm.labels_errori = labels_errori_inglese;
        break;
      case "DE":
        vm.labels = labels_tedesco;
        vm.labels_errori = labels_errori_tedesco;
        break;
      case "FR":
        vm.labels = labels_francese;
        vm.labels_errori = labels_errori_francese;
        break;
      default:
        vm.labels = labels_inglese;
        vm.labels_errori = labels_errori_inglese;
        break;
    }
  } catch (error) {
    vm.registraErrore(error, "ReintroduciPassword-fn_CambiaLingua");
  }
}

function fn_ControllaDati(vm) {
  try {
    let esito = true;

    vm.errori = {};

    if (vm.utente.trim() == "") {
      vm.errori.utente = "dato_obbligatorio";
      esito = false;
    }
    if (vm.password.trim() == "") {
      vm.errori.password = "dato_obbligatorio";
      esito = false;
    } else {
      if (vm.password != vm.conferma_password) {
        vm.errori.password = "password_non_corrispondenti";
        esito = false;
      }
    }
    if (esito) {
      return true;
    } else {
      vm.errori.invia = "si_sono_verificati_degli_errori";
      return false;
    }
  } catch (error) {
    vm.registraErrore(error, "ReintroduciPassword-fn_ControllaDati");
  }
}

function fn_CambiaCursore(cursore, vm) {
  document.querySelector("body").style.cursor = cursore;

  if (cursore == "wait") {
    vm.invio_in_corso = true;
  } else {
    vm.invio_in_corso = false;
  }
}
</script>

<style scoped>
.errore {
  color: red;
  font-weight: 700;
}
</style>
